import React from 'react';
import { ActionStylePreset } from '../../types';
import {
  PropertyMetadata,
  AtomicValueWithNesting,
} from '../../common/abstractStyles/types';
import { StylePresets } from '../../common/presets/StylePresets';

type ShadowPresetsProps = {
  presets: ActionStylePreset[];
  metadata: Record<string, PropertyMetadata>;
  currentDecomposed: Record<string, AtomicValueWithNesting[]>;
  selectedPresetId?: string | null;
  onPresetApplied?: (presetId: string) => void;
};

export const ShadowPresets: React.FC<ShadowPresetsProps> = (props) => {
  return <StylePresets {...props} errorMessagePrefix="shadow preset" />;
};
